<template>
  <div class="select-existing-route-container">
    <ThemedAutocomplete
      :items="allRoutes"
      item-text="description"
      auto-select-first
      no-data-text="No routes found"
      return-object
      cache-items
      outlined
      v-model="selectedRouteModel"
      append-icon="none"
      label="Existing routes"
      persistent-placeholder
      :rules="[selectedRouteRule]"
      dense
    ></ThemedAutocomplete>
  </div>
</template>
  
  
<script>
import { mapState } from "vuex";
import ThemedAutocomplete from "@/core/ThemedAutocomplete.vue";
export default {
  name: "SelectExistingRouteComponent",
  components: {
    ThemedAutocomplete,
  },
  data: function () {
    return {
      selectedRouteRule: () => {
        if (this.useSelectedRoute) {
          return (
            (this.selectedRoute != null && this.selectedRoute != undefined) ||
            "You need to select a route"
          );
        } else {
          return true;
        }
      },
    };
  },
  computed: {
    ...mapState("weatherRouting/routesModule", ["allRoutes"]),
    ...mapState("weatherRouting/formModule", [
      "selectedRoute",
      "useSelectedRoute",
    ]),
    selectedRouteModel: {
      get() {
        return this.selectedRoute;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_SELECTED_ROUTE",
          value,
          { root: true }
        );
        this.$store.commit(
          "weatherRouting/routesModule/SET_SELECTED_ROUTE",
          value
        );
      },
    },
  },
};
</script>

<style scoped>
.select-existing-route-container {
  background-color: var(--color-bg);
  padding-top: 20px;
}
</style>
